import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { colors } from "@/lib/theme";
import { CustomSections } from "@/components/peeps/CustomSections";
import logo from "@/assets/peeps-logo.png";

export default function HowItWorks() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen" style={{ background: colors.surface }}>
      <div className="max-w-2xl mx-auto px-6 py-8">
        <div className="flex items-center gap-2 mb-6">
          <button data-testid="guide-back" onClick={() => (user ? navigate(-1) : navigate("/login"))} className="p-2 -ml-2">
            <ChevronLeft size={22} color={colors.onSurface} />
          </button>
          <button data-testid="home-peeps-button" onClick={() => navigate(user ? "/" : "/login")} className="flex items-center gap-2 transition-transform active:scale-95">
            <img src={logo} alt="peeps" className="w-9 h-9 rounded-xl" />
            <span className="font-display font-bold text-[20px]" style={{ color: colors.brand }}>peeps</span>
          </button>
        </div>

        <h1 className="font-display font-bold text-4xl leading-tight mb-2" style={{ color: colors.onSurface }}>
          How peeps works
        </h1>
        <p className="font-display text-[15px] leading-relaxed mb-2" style={{ color: colors.onSurfaceTertiary }}>
          A quick, practical walkthrough of how to actually use the app — groups, calendars, location, and what stays private.
        </p>

        <CustomSections page="guide" />
      </div>
    </div>
  );
}
